import React from 'react'
import classnames from 'classnames'
import styles from './index.module.css'

const InfoBanner = ({ children, rootStyle }) => (
  <div className={classnames(styles.banner, rootStyle)}>{children}</div>
)

export default InfoBanner
